import { atom } from "recoil"

export const AtomCurrentBgUrl = atom({
    key:'ATOMCURBGURL',
    default:''
})
  